<template>
  <div class="devOps_producerSpaceOther" v-loading="loading">
    <!-- #region 表单搜索部分 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="项目体系" prop="project_system" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.projectSystemId" collapse-tags filterable
                   placeholder="请选择项目体系" clearable>
          <el-option v-for="(key, value) in allSystem.ALLSYSTEMIDS" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务名称">
        <el-input :style="iptStyle" placeholder="请输入" @keyup.enter.native="formSearch('reset')" v-model="form.taskName" />
      </el-form-item>
      <el-form-item label="创建人" prop="creator" :label-width="formLabelWidth">
        <el-select :style="iptStyle" multiple filterable collapse-tags size="mini"  v-model="form.creatorId"  placeholder="请选择">
          <el-option v-for="(key, value) in allUserList.DEVUSER" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="负责人" prop="leading" :label-width="formLabelWidth">
        <el-select :style="iptStyle"  multiple filterable collapse-tags size="mini"  v-model="form.ownerId"  placeholder="请选择负责人">
          <el-option v-for="(key, value) in allUserList.DEVUSER" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务类型">
        <el-select :style="iptStyle" collapse-tags v-model="form.type" multiple filterable
                   placeholder="请选择类型">
          <el-option v-for="(key, value) in NEWOTHERTYPE" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务状态">
        <el-select :style="iptStyle" multiple filterable collapse-tags v-model="form.status"
                   placeholder="请选择任务状态">
          <el-option v-for="(value, key) in allStatusList.ALLSTATUSTYPE6" :key="value" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="实际完成日期" label-width="125px">
        <el-date-picker
            v-model="form.serach_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期" />
      </el-form-item>
      <div>
        <el-form-item>
          <el-button v-if="allMenuList.btn_other_task_query" style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"
                     @click="formSearch('reset','search')">查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="allMenuList.btn_other_task_add"  style="font-weight: bold;letter-spacing: 2px;font-size: 12px;" type="primary"
                     @click="showDialogVisible('create', {})">新增任务
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="allMenuList.btn_other_task_clear" style="font-weight: bold;letter-spacing: 2px;font-size: 12px;" type="primary"
                     @click="changeReset()">置空
          </el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- #endregion 表单搜索部分 -->

    <!-- #region 表格部分 -->
    <div style="height: 60vh;position: relative;">
      <el-table height="100%" stripe :header-cell-style="getCellClass" row-key="id" ref="multipleTable"
                :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
                @sort-change="sortChange" :data="tableData">
        <el-table-column fixed="left" prop="title" min-width="120" label="任务名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span @click="showDialogVisible('create', scope.row)" class="table_text_click_new" v-if="scope.row.id">
              [{{ scope.row.id }}] {{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="left" prop="status_desc"  align="center" width="120" label="任务状态" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="projectSystemName" align="center" width="120" label="项目体系" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="type" align="center" width="90" label="任务类型" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span> {{NEWOTHERTYPE[scope.row.type]}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="priority" align="center" width="62" label="优先级" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="priority_style" :style="allSelect.COLORPRIORITY[scope.row.priority]">
              {{ scope.row.priority }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="creator_id" align="center" width="80" label="创建人" :show-overflow-tooltip="true">
          <!         <template slot-scope="scope">
          <span>{{ scope.row.creator_id.nameZh ? scope.row.creator_id.nameZh : '' }} {{scope.row.creator_id.nameEn ? '('+scope.row.creator_id.nameEn + ')' : ''}}</span>
        </template>
        </el-table-column>
        <el-table-column prop="owner_id" label="负责人" width="90" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.owner_id.nameZh ? scope.row.owner_id.nameZh : '' }} {{scope.row.owner_id.nameEn ? '('+scope.row.owner_id.nameEn + ')' : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" sortable="custom" align="center" width="130" label="创建时间" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="finishDate" sortable="custom" align="center" width="130" label="实际完成日期" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column  fixed="right" align="center" label="操作" width="80"  v-if="allMenuList.btn_other_task_add">
          <template slot-scope="scope">
            <el-button @click="copyTask(scope.row)" type="warning" size="small">复制
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- #endregion 表格部分 -->

    <!-- #region 分页部分 -->
    <div class="block devOpsSpace_page">
      <span class="demonstration">当前页{{ currentPageLength || 0 }}条</span>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="count">
      </el-pagination>
    </div>
    <!-- #endregion -->
    <!-- #region dialog 部分 -->
    <create v-if="dialogVisible.create" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.create'
            :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <pending_processing v-if="dialogVisible.pending_processing" :dialogVisible='dialogVisible.pending_processing'
                        :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <to_be_submitted v-if="dialogVisible.to_be_submitted" :dialogVisible='dialogVisible.to_be_submitted'
                     :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <to_be_verified v-if="dialogVisible.to_be_verified" :dialogVisible='dialogVisible.to_be_verified' :hideDialogVisible="hideDialogVisible"
                    :formInfo="checkedInfo" />
    <!-- #endregion dialog 部分 -->
    <Menu />
  </div>
</template>
<script>

import { create, pending_processing, to_be_submitted, to_be_verified } from './components/other'
import { getDevOpsSpaceOtherListApi, getDevOpsSpaceStageSelectmapApi } from "@/server/tops/devOps";
import { formatEnToUtf8, formatTimeToDate, formatEnToUtf8NoEn } from "@/views/tops/devOps/components/util.js";
import { getStorage, setStorage } from "@/common/utils/storage.js"
import Menu from '@/components/menu/index.vue'
import { mapState, mapMutations } from 'vuex';
export default {
  components: { create, pending_processing, to_be_submitted, to_be_verified,  Menu },
  data() {
    return {
      // 表单搜索条件
      form: {
        status:['0','1','2'],
        serach_time:'',
        ownerId: '',
        projectSystemId: '',
        taskName: '',
        type: '',
      },
      // 列表
      tableData: [],
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      // 弹出层部分
      dialogVisible: {
        create: false,
        pending_processing: false,
        to_be_submitted: false,
        to_be_verified: false,
      },
      // 选中信息
      checkedInfo: {},
      cacheTableData: [],
      count: 10, // 总计
      currentPage: 1, // 当前页
      currentPageLength: 10,
      pageSize: 10, // 每页多少个
      expands: [],
      preciseSwitch: false,
      users: {},
      loading:false,
      tableLoading: false,
      login_username: '',
    };
  },
  async created() {
    let pageSize = getStorage('pageSize', 'localStorage')
    pageSize && (this.pageSize = pageSize * 1);
    this.users = this.allSelect.TEXTUSERSEN;
    await this.$store.dispatch('getDevopsSelect')
    await this.$store.dispatch('getDevopsSystem')
    //全部人员
    await this.$store.dispatch('getDevopsUserList',{userType:''})
    //项目状态
    await this.$store.dispatch('getDevopsStatusList',{type:''})
    await this.$store.dispatch('getDevopsMenuList',{})
    await this.$store.dispatch('getDevopsWorkOrderConfig')
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.NEWALLSYSTEM,
          allUserList: (state) => state.devOps.NEWALLUSERLIST,
          NEWOTHERTYPE: (state) => state.devOps.NEWOTHERTYPE,
          allStatusList: (state) => state.devOps.NEWALLSTATUSLIST,
          allMenuList: (state) => state.devOps.NEWALLMENULIST,
        }
    ),
    /*覅责任*/
    creatorStr() {
      let str = ''
      this.form.creator.forEach(item => {
        str += this.allSelect.TEXTUSERSEN[item] + ' '
      })
      return str;
    },

    /*覅责任*/
    leadingStr() {
      let str = ''
      this.form.leading.forEach(item => {
        str += this.allSelect.TEXTUSERSEN[item] + ' '
      })
      return str;
    },

    /*任务类型*/
    typetaskStr() {
      let str = ''
      this.form.task_type.forEach(item => {
        str += this.allSelect.OTHERTASHOPERATOR[item] + ' '
      })
      return str;
    },
    /*任务状态*/
    statustaskStr() {
      let str = ''
      this.form.status.forEach(item => {
        str += this.allSelect.OTHERTASKSTATUS[item] + ' '
      })
      return str;
    },
    isCreateUser() {
      const roles = this.allUserList['MYROLES']
      if(!roles[3] && !roles[4]){
        return true;
      }
      return false;
    },


  },
  watch: {
    'tableData': {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      },
      deep: true
    }
  },
  async mounted() {
    const { tid = '',ns = '',ids = '', tabid  = ''} = this.$route.query;

    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, user: username ? [username] : []};
    this.login_username = username;
    this.$nextTick(async () => {
      await this.formSearch();
      //this.autoDialogDetailPop(this.tableData)
    })
    if(this.$store.state.devOps.userInfo.userId){
      // let defauleUserId = this.allUserList.ALLUSERIDLIST1[username];
      let defauleUserId = this.$store.state.devOps.userInfo.userId;
      if(this.isCreateUser){
        this.form.creatorId = [defauleUserId.toString()];
      }else{
        this.form.ownerId = [defauleUserId.toString()];
      }
      //this.form.creatorId = [defauleUserId.toString()];
      //this.form.ownerId = [defauleUserId.toString()];
    }
      if(tid){
        this.form.status = '';
        this.form.ownerId = '';
        this.form.creatorId = '';
        this.form.taskName = tid;
      }

    if(ns && ns == 10){
      this.form.status = '';
      this.form.ownerId = '';
      if(this.allUserList.ALLUSERIDLIST1[username]){
        let defauleUserId = this.allUserList.ALLUSERIDLIST1[username];
        this.form.creatorId = [defauleUserId.toString()];
      }
    }
    if(ns && ns == 11){
      this.form.status = ['3'];
    }
      if(ids){
        this.form.status = '';
        this.form.ownerId = '';
        this.form.creatorId = '';
        this.form.taskName = ids;
      }
  },
  methods: {
    ...mapMutations(['filterSelect']),
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 判断任务状态是否已完成
    taskStatusDisabledFn(state,leading,creator) {
      if(this.login_username === 'joseph_ji'){
        return true;
      }
      if(state === 'completed'){
        return false;
      }
      if(state === 'to_be_submitted' || state === 'pending_processing'){
        if(this.login_username ===leading){
          return true;
        }
      }
      if(state === 'to_be_verified'){
        if(this.login_username === creator){
          return true;
        }
      }
      return false;
    },
    // 扩展行
    clickRowHandle(row, column, event) { },
    // 表单搜索
    async formSearch(type,key) {
      this.form.finishDateStart='';
      this.form.finishDateEnd='';
      if(this.form.serach_time){
        if(this.form.serach_time[0]){
          this.form.finishDateStart=this.form.serach_time[0];
        }
        if(this.form.serach_time[1]){
          this.form.finishDateEnd=this.form.serach_time[1];

        }
      }
      if(type === 'reset'){
        this.pageNo = 1;
        this.currentPage = 1;
      }
      try {
        this.$refs.multipleTable.clearSort()
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = this.currentPage
        params.pageSize = this.pageSize
        this.loading = true;
        const ret = await getDevOpsSpaceOtherListApi(params);
        this.tableData = ret.data;
        this.cacheTableData = ret.data;
        this.currentPageLength = ret.data.length;
        this.count = ret.count;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
    },
    autoDialogDetailPop(tableData){
      const { taskid = '' } = this.$route.query;
      if (!tableData.length) return;
      if (taskid) { // 弹阶段详情
        if(tableData[0].status ==='pending_processing' || tableData[0].status === 'to_be_submitted' || tableData[0].status === 'to_be_verified'){
          this.showDialogVisible(tableData[0].status, tableData[0])
        }else{
          this.showDialogVisible('create', tableData[0])
        }

        return;
      }
      return;
    },
    // 公共部分逻辑
    commonTableDataObj(o) {
      const { title, id, user_pm, priority, p_status, p_issue_status, plt, progress, plan_progress, demander, project_system ,reviewed_status} = o;
      return { title, id, user_pm, priority, p_status, p_issue_status, plt, progress, plan_progress, demander, project_system,reviewed_status }
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    // 格式化tableData数据
    formatSortTableData() {
      let arr = []
      this.tableData.forEach(item => {
        if (item.id) {
          const ls = this.tableData.filter(itm => {
            return itm.sortId.startsWith(item.id)
          })
          arr.push(ls)
        }
      })
      return arr;
    },
    // 排序任务时间
    sortTaskTime(key, order) {
      let arr = this.formatSortTableData();
      let newArr = []
      arr.forEach(item => {
        let existDates = [], noExistDates = [];
        let maxDate = 0; // 找出最大日期
        item.forEach(t => {
          const currentDate = t.taskInfo[key];
          if (currentDate && maxDate < currentDate) {
            maxDate = currentDate
          }
          t.taskInfo[key] ? existDates.push(t) : noExistDates.push(t);
        })
        existDates.sort((a, b) => {
          return order === 'descending' ? b.taskInfo[key] - a.taskInfo[key] : a.taskInfo[key] - b.taskInfo[key];
        })
        let tArr = existDates.concat(noExistDates);
        let newTArr = []
        tArr.forEach((t, i) => {
          newTArr.push(i === 0 ? { ...t, maxDate } : t)
        })
        newArr.push(newTArr);
      })
      this.tableData = this.setTableDateHead(newArr, order)
    },
    // 排序需求列表
    setTableDateHead(arr, order) {
      let newArr = [], existDates = [], noExistDates = [];
      arr.forEach(t => {
        t[0].maxDate ? existDates.push(t) : noExistDates.push(t);
      })
      existDates.sort((a, b) => {
        return order === 'descending' ? b[0].maxDate - a[0].maxDate : a[0].maxDate - b[0].maxDate;
      })
      let pArr = existDates.concat(noExistDates);
      pArr.forEach(item => {
        let cacheIdx = 0;
        item.forEach((itm, index) => {
          if (index === 0) {
            const pi = item.filter((it, idx) => {
              if (it.id) {
                cacheIdx = idx;
                return true;
              }
            })
            itm = { ...pi[0], ...itm }
          }
          if (index === cacheIdx && cacheIdx !== 0) {
            itm = { sortId: itm.sortId, taskInfo: itm.taskInfo }
          }
          newArr.push(itm)
        })
      })
      return newArr;
    },
    // 排序事件
    sortChange(column) {
      const { prop, order } = column;

      if(prop === 'createTime') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.createTime) - Date.parse(a.createTime) : Date.parse(a.createTime) - Date.parse(b.createTime);
        })
      }
      if(prop === 'planFinishDate') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.planFinishDate) - Date.parse(a.planFinishDate) : Date.parse(a.planFinishDate) - Date.parse(b.planFinishDate);
        })
      }
    },
    // 弹出模板
    async showDialogVisible(type, row) {
      if (type === 'releaseing') {
        return;
      }
      //await this.hideDialogVisible('', false)
      this.checkedInfo = row;
      this.dialogVisible[type] = true;
    },
    // 隐藏弹窗
    //nextStep = '', search = true
    async hideDialogVisible() {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      await this.formSearch()
      // if (nextStep && (typeof(nextStep) === 'string')) {
      //   //const params = nextStep === 'demand' ? { title: this.checkedInfo?.id} : {}
      //   const params = { title: this.checkedInfo?.id};
      //   const ret = await getDevOpsSpaceOtherListApi(params);
      //   const tableData = ret.data || [];
      //   this.checkedInfo = tableData[0];
      //   this.$nextTick(() => {
      //     this.checkedInfo && (this.dialogVisible[nextStep] = true);
      //   })
      // } else {
      //   search && await this.formSearch()
      // }
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      setStorage('pageSize', val, 'localStorage')
      this.formSearch();
    },
    copyTask(row){
      let data = {...row,openType:'copy'};
      this.showDialogVisible('create',data);
    },
    changeReset(){
      this.form.status = '';
      this.form.ownerId = '';
      this.form.projectSystemId = '';
      this.form.taskName = '';
      this.form.type = '';
      this.form.serach_time = '';


    },
    // 分页事件
    handleCurrentChange(val) {
      this.formSearch();
    },
    // 将英文名字转为中卫
    formatEnToUtf8,
    formatEnToUtf8NoEn,
    // 毫秒值转 YYYY-MM-DD HH:mm:ss
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.devOps_producerSpaceOther {
  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }


  .dialog-footer .el-button {
    font-weight: bold;
    margin-left: 0;
    margin-right: 10px;
  }

  .form_warp .el-form-item {
    margin-bottom: 6px;
  }

  padding-top: 10px;

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
  .priority_style {
    border-radius: 5px;
    text-align: center;
    width: fit-content;
    padding: 0 5px;
    margin: auto;
  }

  .el-dialog__header {
    font-weight: bold;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
}

/* #region 滚动条部分 */
.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* #endregion 滚动条部分 */

.table_options_warp {
  position: absolute;
  z-index: 4;
  left: 20px;
  top: 22px;
  width: 20px;
  cursor: pointer;
}
.devOps_producerSpaceOther .el-form-item__label{
  font-weight: bold;
  font-size: 12px;
}
</style>
